import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import HostListLayer from "../../components/User/UserListLayer";

const HostList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Host Management" />

        <HostListLayer roles="host"/>
      </MasterLayout>
    </>
  );
};

export default HostList;
